export default __webpack_public_path__ + "static/media/cal_icon.6c263d75.svg";